import { OpeningHoursDayExt } from '@/classes/scenario/load/OpeningHoursDayExt';
import { OpeningHours } from '@/dto/scenario/load/OpeningHours';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class OpeningHoursExt extends DtoExt {

  public static fromDto(dto: OpeningHours): OpeningHoursExt {
    return new OpeningHoursExt({
      hasOnlyTypicalDay: dto.hasOnlyTypicalDay,
      typicalDay: dto.typicalDay && OpeningHoursDayExt.fromDto(dto.typicalDay),
      sunday: dto.sunday && OpeningHoursDayExt.fromDto(dto.sunday),
      monday: dto.monday && OpeningHoursDayExt.fromDto(dto.monday),
      tuesday: dto.tuesday && OpeningHoursDayExt.fromDto(dto.tuesday),
      wednesday: dto.wednesday && OpeningHoursDayExt.fromDto(dto.wednesday),
      thursday: dto.thursday && OpeningHoursDayExt.fromDto(dto.thursday),
      friday: dto.friday && OpeningHoursDayExt.fromDto(dto.friday),
      saturday: dto.saturday && OpeningHoursDayExt.fromDto(dto.saturday)
    } as any);
  }

  public hasOnlyTypicalDay: boolean | null = null;

  public typicalDay: OpeningHoursDayExt | null = null;

  public sunday: OpeningHoursDayExt | null = null;
  public monday: OpeningHoursDayExt | null = null;
  public tuesday: OpeningHoursDayExt | null = null;
  public wednesday: OpeningHoursDayExt | null = null;
  public thursday: OpeningHoursDayExt | null = null;
  public friday: OpeningHoursDayExt | null = null;
  public saturday: OpeningHoursDayExt | null = null;

  constructor(options?: OpeningHoursExt | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
      // this.hasOnlyTypicalDay = options.hasOnlyTypicalDay;

      // this.typicalDay = options.typicalDay;

      // this.sunday = options.sunday;
      // this.monday = options.monday;
      // this.tuesday = options.tuesday;
      // this.wednesday = options.wednesday;
      // this.thursday = options.thursday;
      // this.friday = options.friday;
      // this.saturday = options.saturday;
    }
  }

  public toDto(): OpeningHours {
    return new OpeningHours({
      hasOnlyTypicalDay: this.hasOnlyTypicalDay,
      typicalDay: this.typicalDay && this.typicalDay.toDto(),
      sunday: this.sunday && this.sunday.toDto(),
      monday: this.monday && this.monday.toDto(),
      tuesday: this.tuesday && this.tuesday.toDto(),
      wednesday: this.wednesday && this.wednesday.toDto(),
      thursday: this.thursday && this.thursday.toDto(),
      friday: this.friday && this.friday.toDto(),
      saturday: this.saturday && this.saturday.toDto()
    });
  }
}
